export default __webpack_public_path__ + "static/media/Regi_Icon.27e00bea.png";